// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c28f93c8","396":"cda42baa","455":"6f10caeb","977":"976099d1"}[chunkId] + ".chunk.js";
};